document.addEventListener('DOMContentLoaded', function() {
    const urlPath = window.location.pathname;

    // Only execute this script if the URL contains 'products'
    if(urlPath.includes('products')) {
        const productMedias = document.querySelectorAll('.product-media__item video');
        const storyTellingMediaList = document.querySelectorAll('#olivergal-video');
        
        // Get all swiper videos
        const swiperVideos = document.querySelectorAll('.swiper-slide.product-media__item.video video');
        
        // Get all thumbnail items
        const thumbnailItems = document.querySelectorAll('[data-thumbnails-item]');

        // First, let's get the elements we want to hide
        const elementToHide1 = document.querySelector('component-product-badge');

        // Wishlist to Hide
        const wishListIcons = document.querySelectorAll('wishlist-icon');

        // Handle product media events (original functionality)
        if(productMedias.length > 0) {
            productMedias.forEach(productMedia => {
                // Add event listeners to the media element
                productMedia.addEventListener('play', () => {
                    // Hide elements when media starts playing
                    if(elementToHide1) {
                        elementToHide1.classList.add('hidden-strong');
                    }

                    if(wishListIcons.length > 0) {
                        wishListIcons.forEach(wishListIcon => {
                            wishListIcon.classList.add('hidden-strong');
                        })
                    }
                });

                productMedia.addEventListener('ended', () => {
                    // Show elements when media finishes playing
                    if(elementToHide1) {
                        elementToHide1.classList.remove('hidden-strong');
                        elementToHide1.classList.add('flex');
                    }

                    if(wishListIcons.length > 0) {
                        wishListIcons.forEach(wishListIcon => {
                            wishListIcon.classList.remove('hidden-strong');
                            wishListIcon.classList.add('flex');
                        })
                    }
                });

                // Optional: Also handle pause event if you want
                productMedia.addEventListener('pause', () => {
                    // Show elements when media is paused
                    if(elementToHide1) {
                        elementToHide1.classList.remove('hidden-strong');
                        elementToHide1.classList.add('flex');
                        
                    }

                    if(wishListIcons.length > 0) {
                        wishListIcons.forEach(wishListIcon => {
                            wishListIcon.classList.remove('hidden-strong');
                            wishListIcon.classList.add('flex');
                        })
                    }
                });
            });
        }
        
        // Function to handle swiper video autoplay
        function setupSwiperVideoAutoplay() {
            if(swiperVideos.length > 0) {
                console.log(`Found ${swiperVideos.length} swiper videos`);
                
                // Setup video attributes for each swiper video
                swiperVideos.forEach(video => {
                    // Add required iOS attributes
                    video.setAttribute('playsinline', true);
                    video.setAttribute('webkit-playsinline', true);
                    video.setAttribute('muted', true);
                    video.muted = true; // Ensure muted state for autoplay
                    
                    // Check if this video is visible in the active swiper slide
                    const videoSlide = video.closest('.swiper-slide');
                    if(videoSlide && (videoSlide.classList.contains('swiper-slide-active') || 
                                     videoSlide.classList.contains('swiper-slide-visible'))) {
                        if(isElementInViewport(video) && video.paused) {
                            const playPromise = video.play();
                            if (playPromise !== undefined) {
                                playPromise.catch(err => {
                                    console.log("Error playing swiper video:", err);
                                });
                            }
                        }
                    }
                });
                
                // Add visibility check on scroll
                window.addEventListener('scroll', checkSwiperVideoVisibility);
                
                // Set up click handlers for thumbnails
                if(thumbnailItems.length > 0) {
                    thumbnailItems.forEach(item => {
                        item.addEventListener('click', function() {
                            const thumbnailIndex = parseInt(this.getAttribute('data-thumbnails-index'));
                            
                            // Find the corresponding video in the main swiper
                            const targetVideo = document.querySelector(`.swiper-slide.product-media__item.video[data-media-item-index="${thumbnailIndex}"] video`);
                            
                            if(targetVideo) {
                                console.log(`Thumbnail clicked for video at index ${thumbnailIndex}`);
                                
                                // Play the video with sound
                                setTimeout(() => {
                                    targetVideo.setAttribute('playsinline', true);
                                    targetVideo.setAttribute('webkit-playsinline', true);
                                    targetVideo.setAttribute('autoplay', true);
                                    
                                    // Set to unmuted for sound
                                    targetVideo.muted = false;
                                    targetVideo.volume = 1.0;
                                    
                                    const playPromise = targetVideo.play();
                                    if (playPromise !== undefined) {
                                        playPromise.then(() => {
                                            console.log("Video playing with sound after thumbnail click");
                                        }).catch(err => {
                                            console.log("Error playing video with sound:", err);
                                            
                                            // Fallback: try muted first, then unmute
                                            targetVideo.muted = true;
                                            targetVideo.play().then(() => {
                                                // Try to unmute after playback has started
                                                setTimeout(() => {
                                                    targetVideo.muted = false;
                                                    console.log("Attempting to unmute after play started");
                                                }, 100);
                                            }).catch(e => {
                                                console.log("Even muted autoplay failed:", e);
                                            });
                                        });
                                    }
                                }, 300); // Small delay to ensure slide transition completes
                            }
                        });
                    });
                }
                
                // Check for swiper slide change events
                const swipers = document.querySelectorAll('.swiper.product-media__images');
                swipers.forEach(swiper => {
                    if(swiper.swiper) {
                        // If Swiper instance is available
                        swiper.swiper.on('slideChange', function() {
                            setTimeout(checkSwiperVideoVisibility, 100);
                        });
                        
                        swiper.swiper.on('slideChangeTransitionEnd', function() {
                            setTimeout(checkSwiperVideoVisibility, 100);
                        });
                    } else {
                        // Use mutation observer as fallback to detect slide changes
                        const observer = new MutationObserver(function(mutations) {
                            mutations.forEach(function(mutation) {
                                if (mutation.attributeName === 'class') {
                                    setTimeout(checkSwiperVideoVisibility, 100);
                                }
                            });
                        });
                        
                        const swiperSlides = swiper.querySelectorAll('.swiper-slide');
                        swiperSlides.forEach(slide => {
                            observer.observe(slide, { attributes: true });
                        });
                    }
                });
            }
        }
        
        // Function to check if swiper videos are visible and play them
        function checkSwiperVideoVisibility() {
            swiperVideos.forEach(video => {
                const videoSlide = video.closest('.swiper-slide');
                
                // Only auto-play videos in active slides
                if(videoSlide && (videoSlide.classList.contains('swiper-slide-active') || 
                                 videoSlide.classList.contains('swiper-slide-visible'))) {
                    if(isElementInViewport(video) && video.paused) {
                        console.log('Playing swiper video that is in viewport');
                        
                        // For iOS compatibility
                        video.setAttribute('autoplay', true);
                        video.muted = true; // Ensure muted for autoplay
                        
                        const playPromise = video.play();
                        if (playPromise !== undefined) {
                            playPromise.catch(err => {
                                console.log("Error autoplaying swiper video:", err);
                            });
                        }
                    }
                } else {
                    // Pause videos not in active slide
                    if(!video.paused) {
                        video.pause();
                    }
                }
            });
        }

        // Auto-play functionality for storyTellingMediaList videos (original functionality)
        if(storyTellingMediaList && storyTellingMediaList.length > 0) {
            // Store original sources
            const originalSources = [];
            
            storyTellingMediaList.forEach((video, index) => {
                // Add required iOS attributes
                video.setAttribute('playsinline', true);
                video.setAttribute('webkit-playsinline', true);
                
                // Get all source elements within this video
                const sources = video.querySelectorAll('source');
                const sourcesData = [];
                
                sources.forEach(source => {
                    // Store the original source data
                    sourcesData.push({
                        src: source.getAttribute('src'),
                        type: source.getAttribute('type')
                    });
                    
                    // Remove src to prevent loading
                    const dataSrc = source.getAttribute('src');
                    source.removeAttribute('src');
                    source.setAttribute('data-src', dataSrc);
                });
                
                originalSources[index] = sourcesData;
            });
            
            // Create a hidden button for triggering interaction
            const hiddenButton = document.createElement('button');
            hiddenButton.style.position = 'fixed';
            hiddenButton.style.opacity = '0';
            hiddenButton.style.pointerEvents = 'none';
            hiddenButton.style.zIndex = '-1';
            document.body.appendChild(hiddenButton);
            
            // Function to restore video sources and play with sound
            function restoreAndPlay() {
                console.log("User interaction detected! Restoring video sources...");
                
                storyTellingMediaList.forEach((video, index) => {
                    const sources = video.querySelectorAll('source');
                    
                    // Restore sources from our saved data
                    sources.forEach((source, sourceIndex) => {
                        if (originalSources[index] && originalSources[index][sourceIndex]) {
                            source.setAttribute('src', originalSources[index][sourceIndex].src);
                        }
                    });
                    
                    // Load the video with the restored sources
                    video.load();
                    
                    // Set playsinline attribute for iOS
                    video.setAttribute('playsinline', true);
                    
                    // If this video is in viewport, play it with sound
                    if (isElementInViewport(video)) {
                        // For iOS compatibility
                        video.setAttribute('autoplay', true);
                        video.muted = false;
                        
                        // Try to play with sound
                        const playPromise = video.play();
                        
                        if (playPromise !== undefined) {
                            playPromise.then(() => {
                                console.log("Video playing with sound!");
                            }).catch(err => {
                                console.log("Could not play with sound:", err);
                                
                                // iOS Safari fallback - try muted first, then unmute
                                video.muted = true;
                                video.play().then(() => {
                                    // Try to unmute after playback has started
                                    setTimeout(() => {
                                        video.muted = false;
                                    }, 1000);
                                }).catch(e => {
                                    console.log("Even muted autoplay failed:", e);
                                });
                            });
                        }
                    }
                });
                
                // After sources are restored, check for videos in viewport on scroll
                window.addEventListener('scroll', handleVideoVisibility);
                
                // Initialize swiper video autoplay
                setupSwiperVideoAutoplay();
            }
            
            // Function to handle playing/pausing based on visibility
            function handleVideoVisibility() {
                storyTellingMediaList.forEach(video => {
                    if (isElementInViewport(video) && video.paused) {
                        // For iOS compatibility
                        video.setAttribute('autoplay', true);
                        video.muted = false;
                        
                        const playPromise = video.play();
                        if (playPromise !== undefined) {
                            playPromise.catch(err => {
                                console.log("Error playing video:", err);
                                // Try muted as fallback
                                video.muted = true;
                                video.play().then(() => {
                                    // Try to unmute after playback has started
                                    setTimeout(() => {
                                        video.muted = false;
                                    }, 1000);
                                });
                            });
                        }
                    } else if (!isElementInViewport(video) && !video.paused) {
                        video.pause();
                    }
                });
            }
            
            // Add event listeners for user interaction
            const interactionEvents = ['click', 'touchstart', 'mousedown', 'keydown', 'scroll'];
            interactionEvents.forEach(event => {
                document.addEventListener(event, function userInteractionHandler() {
                    // Remove all event listeners after first interaction
                    interactionEvents.forEach(e => {
                        document.removeEventListener(e, userInteractionHandler);
                    });
                    
                    // Restore sources and play videos
                    restoreAndPlay();
                }, { once: false, passive: true });
            });
            
            // Auto-trigger interaction after a very short delay
            setTimeout(() => {
                hiddenButton.click();
            }, 100);
        } else {
            // If there are no storytelling videos, still set up swiper autoplay
            setupSwiperVideoAutoplay();
        }
    }
});

function isElementInViewport(el) {
    if (typeof jQuery === "function" && el instanceof jQuery) {
        el = el[0];
    }
    const rect = el.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    
    // Element is in viewport when it's at least 50% visible
    const visibleHeight = Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);
    const elementHeight = rect.bottom - rect.top;
    
    return visibleHeight >= elementHeight * 0.5;
}